import { render } from "./ShopItem.vue?vue&type=template&id=67456ebb"
import script from "./ShopItem.vue?vue&type=script&lang=js"
export * from "./ShopItem.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__